<template>
  <div>
    <!-- Search Bar -->
    <multi-select
      :options="options"
      :selected-options="newitems"
      placeholder="select item"
      @select="onSelect"
    >
    </multi-select>

    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">Products List</span>
        <button
          class="pull-right btn btn-primary"
          @click="add_vendor_product_model = !add_vendor_product_model"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
      <b-modal
        v-model="add_vendor_product_model"
        title="Add Own Product"
        hide-footer=""
      >
        <div v-show="addProductloading">
          <div class="col-md-12 text-center">
            <sweetalert-icon :icon="loadingType" />
          </div>
          <div class="col-md-12 text-center">
            <h3 class="text-center">{{ loadingMessage }}</h3>
          </div>
        </div>
        <b-form v-on:submit.prevent="SaveProducts" v-show="!addProductloading">
          <b-form-group label="Select Category:">
            <b-form-select
              v-model="newProducts.productCategoryId"
              required
              class="form-control"
              @change="fetchProduct()"
              :options="categorylist"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Select Product:">
            <b-form-select
              v-model="newProducts.productsId"
              required
              class="form-control"
              :options="productlist"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Product MRP:">
            <b-form-input
              v-model.number="newProducts.mrp"
              type="number"
              required
              class="form-control"
              placeholder="Enter MRP of Product"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Selling Price:">
            <b-form-input
              v-model.number="newProducts.sellPrice"
              type="number"
              required
              class="form-control"
              placeholder="Enter Selling Price of Product"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Stock :">
            <b-form-input
              v-model.number="newProducts.stock"
              type="number"
              required
              class="form-control"
              placeholder="Enter Stock of Product"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Moq :">
            <b-form-input
              v-model.number="newProducts.moq"
              type="number"
              required
              class="form-control"
              placeholder="Enter Minimum Order Qty"
            ></b-form-input>
          </b-form-group>
          <button type="submit" class="btn btn-success btn-lg">Save</button>
        </b-form>
      </b-modal>
      <div class="card-body">
        <div class="table-responsive">
          <b-container fluid>
            <b-table
              :key="flag"
              show-empty
              small
              stacked="md"
              :busy="loading"
              :items="vendorProducts"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <!-- <template v-slot:cell(sr)="data">
                {{++number}}
              </template> -->

              <template v-slot:cell(photo)="data">
                <img
                  :src="getProduct(data.item.productsId, 'image')"
                  height="50px;"
                  weight="50xp;"
                />
              </template>

              <template v-slot:cell(productname)="data">
                {{ getProduct(data.item.productsId, "name") }}
              </template>

              <template v-slot:cell(category)="data">
                {{ getCategory(data.item.productCategoryId, "name") }}
              </template>

              <template v-slot:cell(unittype)="data">
                {{ getProduct(data.item.productsId, "unitType") }}
              </template>

              <template v-slot:cell(price)="data">
                <strong> {{ data.item.sellPrice }}</strong> /
                <del>{{ data.item.mrp }}</del>
              </template>

              <template v-slot:cell(status)="data">
                <b-badge variant="success" v-if="data.item.status == true"
                  >Approve</b-badge
                >
                <b-badge variant="danger" v-else>Disapprove</b-badge>
              </template>

              <template v-slot:cell(action)="data">
                <button
                  class="btn btn-warning btn-sm"
                  @click="editProduct(data.item)"
                >
                  <i class="fa fa-pencil"></i>
                </button>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
            <b-row>
              <b-col sm="4" md="4" lg="4" class="my-1">
                <!-- Testing Pagination -->
                <b-pagination
                  v-model="pagicurrentPage"
                  :total-rows="rows"
                  :per-page="pagiperPage"
                ></b-pagination>

                <p class="mt-3">Current Page: {{ pagicurrentPage }}</p>
              </b-col>
            </b-row>
          </b-container>

          <b-modal
            v-model="edit_product_model"
            title="Edit Products"
            hide-footer=""
          >
            <div v-show="addProductloading">
              <div class="col-md-12 text-center">
                <sweetalert-icon :icon="loadingType" />
              </div>
              <div class="col-md-12 text-center">
                <h3 class="text-center">{{ loadingMessage }}</h3>
              </div>
            </div>
            <b-form
              v-on:submit.prevent="UpdateProducts"
              v-show="!addProductloading"
            >
              <b-form-group label="Product MRP:">
                <b-form-input
                  v-model.number="editProducts.mrp"
                  type="number"
                  required
                  class="form-control"
                  placeholder="Enter MRP of Product"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Selling Price:">
                <b-form-input
                  v-model.number="editProducts.sellPrice"
                  type="number"
                  required
                  :max="editProducts.mrp"
                  class="form-control"
                  placeholder="Enter Selling Price of Product"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Stock :">
                <b-form-input
                  v-model.number="editProducts.stock"
                  type="number"
                  required
                  class="form-control"
                  placeholder="Enter Stock of Product"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Moq :">
                <b-form-input
                  v-model.number="editProducts.moq"
                  type="number"
                  required
                  class="form-control"
                  placeholder="Enter Minimum Order Qty"
                ></b-form-input>
              </b-form-group>
              <button type="submit" class="btn btn-success btn-lg pull-right">
                Update
              </button>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { MultiSelect } from "vue-search-select";
import { mapGetters } from "vuex";
import { dbFs, checkProductInVendor } from "@/modules/database";
export default {
  data() {
    return {
      flag: 0,
      pagiperPage: 10,
      pagicurrentPage: 1,
      vendorProductCopy: [],
      overallproductsofvendor: [],
      overallproducts: [],
      newitems: [],
      searchText: "",
      lastSelectItem: {},
      index: 0,
      options: [],
      loading: false,
      dataTable: null,
      addProductloading: false,
      add_vendor_product_model: false,
      edit_product_model: false,
      loadingType: "loading",
      loadingMessage: "Uploading",
      vendorProducts: [],
      products: [],
      vendors: [],
      category: [],
      categorylist: [],
      productlist: [],
      newProducts: {
        created: {
          ip: "",
          timestamp: "",
          uId: ""
        },
        mrp: 0,
        productCategoryId: null,
        productsId: null,
        sellPrice: 0,
        status: true,
        stock: 0,
        moq: 0,
        vendorId: ""
      },
      editProducts: {
        mrp: 0,
        sellPrice: 0,
        status: true,
        stock: 0,
        moq: 0
      },
      editproductId: "",
      number: 0,
      fields: [
        {
          key: "sr",
          label: "#",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "photo",
          label: "Photo",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "productname",
          label: "Products Name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "category",
          label: "Products Category",
          sortable: true,
          class: "text-center"
        },
        {
          key: "unittype",
          label: "Unit Type",
          sortable: false,
          class: "text-center"
        },
        {
          key: "stock",
          label: "Stock",
          sortable: true,
          class: "text-center"
        },
        {
          key: "moq",
          label: "MOQ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "price",
          label: "Price",
          sortable: true,
          class: "text-center"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "text-center"
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
          class: "text-center"
        }
      ],
      items: [],
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: []
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
      // products: "getProducts",
      // vendorProducts: "getVendorProducts"
    }),
    rows() {
      return this.overallproductsofvendor.length;
    }
  },
  mounted() {
    this.setupFirebaseReading();
    this.getnames();
    this.allVendorProducts();
    this.allproducts();
    this.getCategoryData();
    this.getProductsData();
    this.getVendorsData();
    this.getCreatedAt();
  },
  methods: {
    // async setupFirebaseReading() {
    //   await Promise.all(this.vendorProducts, this.products);
    //   // this.forDataTable();
    // },
    getCreatedAt() {
      fetch("https://api.ipify.org?format=json")
        .then(x => x.json())
        .then(({ ip }) => {
          this.newProducts.created.ip = ip;
          this.newProducts.created.timestamp = Math.round(+new Date() / 1000);
          this.newProducts.created.uId = this.$route.params.vendorId;
          this.newProducts.vendorId = this.$route.params.vendorId;
        });
    },
    setupFirebaseReading: function() {
      var count1 = 0;
      this.loading = true;
      dbFs
        .collection("vendorProducts")
        .where("vendorId", "==", this.$route.params.vendorId)
        .limit(10)
        .get()
        .then(res => {
          res.forEach(doc => {
            let data = doc.data();
            this.vendorProducts.push({
              id: doc.id,
              moq: data.moq,
              mrp: data.mrp,
              productCategoryId: data.productCategoryId,
              productsId: data.productsId,
              sellPrice: data.sellPrice,
              status: data.status,
              stock: data.stock,
              vendorId: data.vendorId
            });
          });
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.forDataTable();
          this.vendorProductCopy = this.vendorProducts;
          this.vendorProducts.forEach(doc => {
            doc["sr"] = ++count1;
          });
        });
    },
    getnames() {
      this.loading = true;
      let count = 0;
      dbFs
        .collection("products")
        .get()
        .then(res => {
          res.forEach(doc => {
            var obj = {
              value: ++count,
              text: doc.data().name
            };
            this.options.push(obj);
          });
        });
    },
    allVendorProducts() {
      var count1 = 0;
      this.loading = true;
      dbFs
        .collection("vendorProducts")
        .get()
        .then(res => {
          res.forEach(doc => {
            let data = doc.data();
            this.overallproductsofvendor.push({
              id: doc.id,
              moq: data.moq,
              mrp: data.mrp,
              productCategoryId: data.productCategoryId,
              productsId: data.productsId,
              sellPrice: data.sellPrice,
              status: data.status,
              stock: data.stock,
              vendorId: data.vendorId
            });
          });
          this.overallproductsofvendor.forEach(doc => {
            doc["sr"] = ++count1;
          });
        })
        .catch(err => console.log(err));
    },
    allproducts() {
      this.loading = true;
      this.$bind("overallproducts", dbFs.collection("products"));
    },
    getCategoryData() {
      this.loading = true;
      this.$bind("category", dbFs.collection("productCategory"))
        .then(() => {
          this.categorylist.push({
            value: null,
            text: "Select Category"
          });
          for (let index = 0; index < this.category.length; index++) {
            this.categorylist.push({
              value: this.category[index].categoryId,
              text: this.category[index].name
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductsData() {
      this.loading = true;
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVendorsData() {
      this.loading = true;
      this.$bind("vendors", dbFs.collection("vendor"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCategory(id, dataType) {
      let categoryDetails = {
        name: "Not Found",
        img: ""
      };
      for (const cusKey of Object.keys(this.category)) {
        const category = this.category[cusKey];
        if (id == category.id) {
          categoryDetails = category;
        }
      }
      if (dataType == "name") {
        return categoryDetails.name;
      }
      if (dataType == "image") {
        return categoryDetails.img;
      }
    },
    getProduct(id, dataType) {
      let productDetails = {
        name: "Not Found",
        unitType: "",
        image: ""
      };
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getVendor(id, dataType) {
      let VendorDetails = {
        shopDetails: {
          name: "Not Found",
          address: {
            firstLine: "",
            city: "",
            state: "",
            pincode: ""
          }
        },
        personalDetails: {
          name: "Not Found"
        }
      };
      for (const cusKey of Object.keys(this.vendors)) {
        const vendor = this.vendors[cusKey];
        if (id == vendor.id) {
          VendorDetails = vendor;
        }
      }
      if (dataType == "shopname") {
        return VendorDetails.shopDetails.name;
      }
      if (dataType == "ownername") {
        return VendorDetails.personalDetails.name;
      }
      if (dataType == "address") {
        let address = `${VendorDetails.shopDetails.address.firstLine},
        ${VendorDetails.shopDetails.address.city},
        ${VendorDetails.shopDetails.address.state},
        ${VendorDetails.shopDetails.address.pincode}`;
        return address;
      }
    },
    fetchProduct() {
      this.productlist = [];
      this.productlist.push({
        value: null,
        text: "Select Product"
      });
      this.newProducts.productsId = null;
      for (const product of this.products) {
        if (product.productCategory == this.newProducts.productCategoryId) {
          this.productlist.push({
            value: product.id,
            text: product.name
          });
        }
      }
    },
    SaveProducts() {
      this.addProductloading = true;
      this.loadingMessage = "Adding Products";
      checkProductInVendor(this.newProducts.productsId)
        .then(value => {
          if (value == "NotFound") {
            dbFs
              .collection("vendorProducts")
              .add(this.newProducts)
              .catch(error => {
                console.log(error);
              })
              .finally(() => {
                this.loadingType = "success";
                this.loadingMessage = "Products Added Successfull";
                setTimeout(() => {
                  (this.add_vendor_product_model = false),
                    (this.addProductloading = false);
                }, 3000);
              });
          } else {
            this.loadingType = "error";
            this.loadingMessage = "Product Allready Added";
            setTimeout(() => {
              (this.add_vendor_product_model = false),
                (this.addProductloading = false);
            }, 3000);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    editProduct(product) {
      this.editproductId = product.id;
      this.editProducts = {
        mrp: product.mrp,
        sellPrice: product.sellPrice,
        stock: product.stock,
        status: true,
        moq: product.moq
      };
      this.edit_product_model = true;
    },
    UpdateProducts() {
      this.addProductloading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Updating Products";
      let id = this.editproductId;
      dbFs
        .collection("vendorProducts")
        .doc(id)
        .update(this.editProducts)
        .then(() => {
          this.loadingType = "success";
          this.loadingMessage = "Product Update";
          setTimeout(() => {
            this.editproductId = "";
            this.editProducts = {
              mrp: 0,
              sellPrice: 0,
              status: true,
              stock: 0,
              moq: 0
            };
            this.edit_product_model = false;
            this.addProductloading = false;
          });
        })
        .finally(() => {
          this.overallproductsofvendor.forEach(doc => {
            if (doc.id === id) {
              doc.mrp = this.editProducts.mrp;
              doc.sellPrice = this.editProducts.sellPrice;
              doc.stock = this.editProducts.stock;
              doc.moq = this.editProducts.moq;
            }
          });
          this.vendorProducts.forEach(doc => {
            if (doc.id === id) {
              doc.mrp = this.editProducts.mrp;
              doc.sellPrice = this.editProducts.sellPrice;
              doc.stock = this.editProducts.stock;
              doc.moq = this.editProducts.moq;
            }
          });
        });
    },
    forDataTable() {
      this.dataTable = $("#dataTable").DataTable({
        lengthMenu: [10, 20]
      });
    },
    onSelect(items, lastSelectItem) {
      if (items.length != 0) {
        this.newitems = items;
        this.lastSelectItem = lastSelectItem;
        var x = [];
        this.newitems.forEach(ele => {
          var prodid = "";
          this.overallproducts.forEach(doc => {
            if (ele.text === doc.name) {
              prodid = doc.productId;
            }
          });
          this.overallproductsofvendor.forEach(doc => {
            if (prodid === doc.productsId) {
              x.push(doc);
            }
          });
        });
        this.vendorProducts = x;
      } else {
        this.newitems = items;
        this.lastSelectItem = lastSelectItem;
        this.vendorProducts = this.vendorProductCopy;
      }
    }
    // UpdateAllProducts() {
    //   console.log("work");
    //   this.overallproductsofvendor.forEach(doc => {
    //     let id = doc.id;
    //     this.updateAllDetails(id, doc);
    //   });
    // },
    // updateAllDetails(id, doc) {
    //   let moq = parseFloat(doc.moq);
    //   let mrp = parseFloat(doc.mrp);
    //   let sellPrice = parseFloat(doc.sellPrice);
    //   let stock = parseFloat(doc.stock);
    //   // console.log(sellPrice);
    //   dbFs
    //     .collection("vendorProducts")
    //     .doc(id)
    //     .update({
    //       moq: moq,
    //       mrp: mrp,
    //       sellPrice: sellPrice,
    //       stock: stock
    //     });
    // }
  },
  components: {
    MultiSelect
  },
  watch: {
    pagicurrentPage(newValue) {
      this.vendorProducts = [];
      var indexstart = (newValue - 1) * 10;
      var indexend = indexstart + 9;
      for (var x = indexstart; x <= indexend; x++) {
        if (this.overallproductsofvendor[x]) {
          this.vendorProducts.push(this.overallproductsofvendor[x]);
        }
      }
    }
  }
};
</script>

<style scoped></style>
